import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode, useMemo } from 'react';

import { shortFormatDate } from '@/utils/dates';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

const lastUpdated = 1648227762; // March 25, 2022

export const NationalLogisticServicePolicy = () => {
    const formatMessage = useAppFormatMessage();

    const policyRichTextValues = useMemo(() => {
        let newlineSerial = 0;
        let listItemSerial = 0;
        let strongSerial = 0;
        return {
            h2: (content: ReactNode) => <H2 key="national-logistic-services-policy-h2">{content}</H2>,
            ListItem: (content: ReactNode) => (
                <div
                    className="inline-block pl-md -indent-md"
                    key={`national-logistic-services-policy-li-${listItemSerial++}`}
                >
                    <span>{content}</span>
                </div>
            ),
            newline: () => <br key={`national-logistic-services-policy-nl-${newlineSerial++}`} />,
            strong: (content: ReactNode) => (
                <strong key={`national-logistic-services-policy-s-${strongSerial++}`}>{content}</strong>
            ),
        };
    }, []);

    return (
        <>
            <div className="mb-sm">
                <BodyPrimary color="secondary">
                    {formatMessage(['partners', 'lastUpdated'], { values: { date: shortFormatDate(lastUpdated) } })}
                </BodyPrimary>
            </div>
            {formatMessage(['partners', 'nationalLogisticServices', 'policy'], {
                values: policyRichTextValues,
            })}
        </>
    );
};
